import * as ko from "knockout";
import * as moment from "moment";
import * as Clipboard from "clipboard";
import { CopyToClipboardOptions } from "../ViewModels/viewmodelbase";
import * as Chart from "chart.js";
import { KnockoutExtensions } from "./knockoutextensions";

/**
 * Executes the MDL upgradeElement method on the bound element. Useful for templates where the MDL
 * wiring will not execute automatically.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).upgradeElement = {
    init(element: HTMLElement) {
        componentHandler.upgradeElement(element);
    }
};

/**
 * Associates a rendering function with an element set up for jQuery UI AutoComplete.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).autoCompleteRenderer = {
    // tslint:disable-next-line
    init(element: HTMLElement, valueAccessor: any) {
        // tslint:disable-next-line
        ($(element).autocomplete("instance") as any)._renderItem = valueAccessor();
    }
};

/**
 * Configures an input element as an MDL text field.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).debug = {
    // tslint:disable-next-line
    init(element: HTMLElement, valueAccessor: any) {
            console.log('Knockoutbinding:');
            console.log(element);
            console.log(ko.toJS(valueAccessor()));
        }
};

/**
 * Configures an input element as an MDL text field.
 */
// tslint:disable-next-line
ko.bindingHandlers.selected = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var selected = ko.utils.unwrapObservable(valueAccessor());
        if (selected) element.select();
    }
};

/**
 * Configures an input element as an MDL text field.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlInput = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingDiv = $("<div class='input-wrapper'>").insertAfter($el);
        const $label = $("<label>");
        const params = valueAccessor();

        const allBindings = allBindingsAccessor();

        const isFloating = (params.isFloatingLabel == null || params.isFloatingLabel !== false);
        const isNumber = (params.isNumber != null && params.isNumber === true);
        const isFullWidth = (params.isFullWidth != null && params.isFullWidth);
        const isLarge = (params.isLarge != null && params.isLarge);
        const hasLabel = (params.hasLabel == null || params.hasLabel !== false);
        const hasHelp = (params.hasHelp === undefined || params.hasHelp == null || params.hasHelp == false) ? false : true;
        const helpLink = params.helpLink;
        const helpLeft = params.helpLeft;

        const $help = $("<a class='card-help-icon-link' href='" + helpLink + "' target='_blank'><i id='help1Info' class='card-help-icon-input material-icons notranslate'>help_outline</i></a>");
        if (helpLeft != null) {
            $help.attr("style", "left:" + helpLeft);
        }

        $el.attr("id", params.id);
        $label.attr("for", params.id).text(params.label);
        $el.addClass("mdl-textfield__input");

        if (params.containerClass) {
            $enclosingDiv.addClass(params.containerClass);
        }

        $enclosingDiv.addClass("mdl-textfield mdl-js-textfield");
        if (isFloating) {
            $enclosingDiv.addClass("mdl-textfield--floating-label");
        } 

        if (isNumber) {
            //$el.attr("pattern", "^-?[0-9]*(\.[0-9]+)?$");
            $enclosingDiv.addClass("mdl-textfield--numeric");
        }

        if (isFullWidth) {
            $enclosingDiv.addClass("mdl-textfield--fullwidth");
        }

        if (isLarge) {
            $enclosingDiv.addClass("mdl-textfield--large");
        }

        if (hasLabel) {
            if (isFloating) {
                if (!hasHelp) {
                    $enclosingDiv.append($el).append($label);                
                } else {
                    $enclosingDiv.append($el).append($label).append($help);
                }
                $label.addClass("mdl-textfield__label");
            } else {
                if (!hasHelp) {
                    $enclosingDiv.append($label).append($el);
                } else {
                    $enclosingDiv.append($label).append($help).append($el);
                }
                $label.addClass("mdl-textfield__fixed-label");
            }
        } else {
            $label.addClass("mdl-textfield__label");            
            if (!hasHelp) {
                $enclosingDiv.append($label).append($el);
            } else {
                $enclosingDiv.append($label).append($help).append($el);
            }
        }

        if (params.visible != null) {
            ko.applyBindingsToNode($enclosingDiv[0], () => {
                const value = valueAccessor();
                return { visible: value.visible };
            });
        }

        ko.applyBindingsToNode($el.get(0), { valueUpdate: "keyup" });

        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingDiv.get(0) as any) as HTMLElement);
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any) => {
        const params = allBindingsAccessor();
        const value = params.value != null
            ? params.value() : params.textInput != null
                ? params.textInput() : params.textInputWithDefault != null
                    ? params.textInputWithDefault() : null;
        const isDisabled = $(element).attr("disabled") != null;
        $(element).parent().toggleClass("is-disabled", isDisabled);
        $(element).parent()[value != null ? "addClass" : "removeClass"]("is-dirty");
    }
};


/**
 * Configures a button element as an MDL menu button, by creating the associated menu instance from a template.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlMenu = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const params = valueAccessor();
        const baseId = $el.attr("id");
        const templateId = params.template;
        const position = params.position || "bottom-left";

        $el.addClass("mdl-button mdl-js-button mdl-button--icon");

        const $list = $(KnockoutExtensions.getTemplateByName(templateId))
            .addClass(`mdl-menu mdl-menu--${position} mdl-js-menu mdl-js-ripple-effect`)
            .attr("for", baseId);

        $el.after($list);

        ko.applyBindingsToDescendants(context, $list.get(0));

        // tslint:disable-next-line
        componentHandler.upgradeElement(($el.get(0) as any) as HTMLElement);
        // tslint:disable-next-line
        componentHandler.upgradeElement(($list.get(0) as any) as HTMLElement);

        return { 'controlsDescendantBindings': true };
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {
        ko.applyBindingsToDescendants(context, element);
    }
};


// tslint:disable-next-line
(ko.bindingHandlers as any).mdlExtMenu = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const params = valueAccessor();
        const baseId = $el.attr("id");
        const templateId = params.template;
        const parentId = params.parentId;
        const isInDialog = params.isInDialog;
        const embedInDialog = params.embedInDialog;
        //const listElementId = params.listElementId;

        $el.addClass("mdl-button mdl-js-button mdl-button--primary action-button mdlext-js-menu-button action-button");

        const menuId = baseId + "-menu";
        var $list = null;
        //if (templateId !== null && templateId !== undefined) {
            $list = $(KnockoutExtensions.getTemplateByName(templateId))
                .addClass("mdlext-menu")
                .attr("id", menuId);        
        //} else {
        //    $list = $('#' + listElementId)
        //        .addClass("mdlext-menu")
        //        .attr("id", menuId);
        //}

        $el.after($list);
      

        // tslint:disable-next-line
        componentHandler.upgradeElement(($el.get(0) as any) as HTMLElement);
        // tslint:disable-next-line
        componentHandler.upgradeElement(($list.get(0) as any) as HTMLElement);

        ko.applyBindingsToDescendants(context, $list.get(0));   //moving this below the two line above fixes a problem where the menus aren't closing properly.

        if (isInDialog) {
            // To ensure that the list is visible when using mdl-extmenu on a dialog
            const $finalList = $("#" + menuId);
            $el.after($finalList);
        }

        return { 'controlsDescendantBindings': true };
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {
        ko.applyBindingsToDescendants(context, element);
    }
};


/**
 * Configures an element as an MDL dialog with bindings to the DialogViewModel type.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlDialog = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $dialog = $(element).addClass("mdl-dialog");

        const $title = $("<h4/>")
            .addClass("mdl-dialog__title")
            .attr("data-bind", "text: title");
        $dialog.append($title);

        var $busyOverlay = $("<div/>")
            .addClass("busy-overlay")
            .attr("data-bind", "visible: isBusy");
        var $content = $("<div/>")
            .addClass("mdl-dialog__inner-content-container");
        if (data != null) {
            $content.html(data.content);
        }
        const $contentWrapper = $("<div/>")
            .addClass("mdl-dialog__content")
            .append($content)
            .append($busyOverlay);

        $dialog.append($contentWrapper);

        const $actions = $("<div/>")
            .addClass("mdl-dialog__actions")
            .attr("data-bind", "foreach: actions");

        const $actionButton = $("<button/>")
            .attr("type", "button")
            .addClass("mdl-button mdl-js-button mdl-button--primary")
            .attr("data-bind", "text: caption, click: action");

        $actions.append($actionButton);
        $dialog.append($actions);

        ko.applyBindingsToDescendants(context, $dialog.get(0));

        // tslint:disable-next-line
        componentHandler.upgradeElement(($dialog.get(0) as any) as HTMLElement);

        return { 'controlsDescendantBindings': true };
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {
        if (data != null) {
            const $contentDiv = $(".mdl-dialog__content .mdl-dialog__inner-content-container", element);
            $contentDiv.html(data.content);
            ko.applyBindingsToDescendants(context, $contentDiv.get(0));
        }
    }
};

/**
 * Configures an input element as an MDL checkbox.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlCheckbox = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingLabel = $("<label class='input-wrapper'>").insertAfter($el);
        const $captionSpan = $("<span>");
        const params = valueAccessor();

        $el.attr("id", params.id);
        $el.addClass("mdl-checkbox__input");
        $enclosingLabel.attr("for", params.id);

        if (ko.isObservable(params.label)) {
            ko.applyBindingsToNode($enclosingLabel[0], { text: params.label });
        } else {
            $captionSpan.text(params.label);
        }

        $captionSpan.addClass("mdl-checkbox__label");
        $enclosingLabel.addClass("mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect").append($el).append($captionSpan);

        if (params.containerClass) {
            $enclosingLabel.addClass(params.containerClass);
        }

        if (params.visible) {
            ko.applyBindingsToNode($enclosingLabel[0], { visible: params.visible });
        }

        ko.bindingHandlers.checked.init(element, () => params.checked, allBindingsAccessor, data, context);

        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingLabel[0] as any) as HTMLElement);

        if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }

        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any) => {
        // mdl does not reflect the initial checked value, so we do that explicitly here
        const params = valueAccessor();
        const $enclosingLabel = $(element).parent("label");
        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
        else {
            $enclosingLabel.removeClass("is-checked");
        }
        if (params.isDisabledOverride === false) {
            $enclosingLabel.addClass("is-disabled");
        }
        else if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }
    }
};

/**
 * Configures an input element as an MDL checkbox.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlSwitch = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingLabel = $("<label class='input-wrapper'>").insertAfter($el);
        const $captionSpan = $("<span>");
        const params = valueAccessor();

        $el.attr("id", params.id);
        $el.addClass("mdl-switch__input");
        $enclosingLabel.attr("for", params.id);

        if (ko.isObservable(params.label)) {
            ko.applyBindingsToNode($captionSpan[0], { text: params.label });
        } else {
            $captionSpan.text(params.label);
        }

        $captionSpan.addClass("mdl-switch__label");
        $enclosingLabel.addClass("mdl-switch mdl-js-switch mdl-js-ripple-effect").append($el).append($captionSpan);
        
        if (params.containerClass) {
            $enclosingLabel.addClass(params.containerClass);
        }

        if (params.visible) {
            ko.applyBindingsToNode($enclosingLabel[0], { visible: params.visible });
        }
        
        ko.bindingHandlers.checked.init(element, () => params.checked, allBindingsAccessor, data, context);
        
        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingLabel[0] as any) as HTMLElement);

        if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }

        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any) => {
        // mdl does not reflect the initial checked value, so we do that explicitly here
        const params = valueAccessor();
        const $enclosingLabel = $(element).parent("label");
        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
        else {
            $enclosingLabel.removeClass("is-checked");
        }
        if (params.isDisabledOverride === false) {
            $enclosingLabel.addClass("is-disabled");
        }
        else if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }
    }
};



/**
 * Configures an input element as an MDL radio button.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlRadioButton = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingLabel = $("<label>").insertAfter($el);
        const $captionSpan = $("<span>");
        const params = valueAccessor();
        const allParams = allBindingsAccessor();

        $el.attr("id", params.id);
        $el.addClass("mdl-radio__button");
        $enclosingLabel.attr("for", params.id);

        if (ko.isObservable(params.label)) {
            ko.applyBindingsToNode($enclosingLabel[0], { text: params.label });
        } else {
            $captionSpan.text(params.label);
        }

        $captionSpan.addClass("mdl-radio__label");
        $enclosingLabel.addClass("mdl-radio mdl-js-radio mdl-js-ripple-effect").append($el).append($captionSpan);

        if (params.containerClass) {
            $enclosingLabel.addClass(params.containerClass);
        }

        if (params.visible) {
            ko.applyBindingsToNode($enclosingLabel[0], { visible: params.visible });
        }

        //ko.bindingHandlers.checked.init(element, valueAccessor, allBindingsAccessor, data, context);

        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingLabel[0] as any) as HTMLElement);

        if (allParams.checked() === allParams.checkedValue) {
            $enclosingLabel.addClass("is-checked");
        }
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any) => {
        // mdl does not reflect the initial checked value, so we do that explicitly here
        const allParams = allBindingsAccessor();
        const $enclosingLabel = $(element).parent("label");
        $enclosingLabel.toggleClass("is-checked", allParams.checked() === allParams.checkedValue);
        if (allParams.disable != null) {
            $enclosingLabel.toggleClass("is-disabled", ko.unwrap(allParams.disable));
        }
    }
};
/**
 * Validation extension to set a conditional required validation rule on an observable.
 */
// tslint:disable-next-line
(<any>ko.extenders).requiredOnlyIf = (target: any, makeRequired: () => boolean) => {
    target.HasError = ko.pureComputed(() => {
        const otherHasValue = makeRequired();
        const targetHasValue = !!target();

        return otherHasValue && !targetHasValue;
    });

    return target;
};

/**
 * Some default common ignore fields.
 */
ko.mapping.defaultOptions().ignore = ["parent", "errors"];

/**
 * Configures an input field to work with date values.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).date = {
    // https://disqus.com/home/discussion/jasonmitchellcom/binding_and_formatting_dates_using_knockout_and_moment_js/#comment-1374417079
    // tslint:disable-next-line
    init: (element: any, valueAccessor: any) => {
        ko.utils.registerEventHandler(element, "change", () => {
            const value = valueAccessor();
            if (element.value !== null && element.value !== undefined && element.value.length > 0) {
                value(element.value);
            }
            else {
                value("");
            }
        });
    },
    // tslint:disable-next-line
    update: (element: any, valueAccessor: any, allBindingsAccessor: any) => {
        const value = valueAccessor();
        const allBindings = allBindingsAccessor();
        const valueUnwrapped = ko.utils.unwrapObservable(value);

        // Date formats: http://momentjs.com/docs/#/displaying/format/
        const pattern = allBindings.format || "DD/MM/YYYY";

        let output = "-";
        if (valueUnwrapped !== null && valueUnwrapped !== undefined && valueUnwrapped.length > 0) {
            output = moment(valueUnwrapped).format(pattern);
        }

        if ($(element).is("input")) {
            $(element).val(output);
        } else {
            $(element).text(output);
        }
    }
};

/**
 * Binding handler that fires a method when the enter key is pressed.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).enterkey = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        const callback = valueAccessor();
        $(element).keypress((event) => {
            const keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(data);
                return false;
            }
            return true;
        });
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).textInputWithDefault = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, bindingContext: any) => {
        var property = valueAccessor();
        var value = (element as HTMLInputElement).value;
        if (property() == null) {
            property(value);
        }
        ko.bindingHandlers.textInput.init(element, valueAccessor, allBindingsAccessor, data, bindingContext);
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).fadeVisible = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        // Initially set the element to be instantly visible/hidden depending on the value
        var value = valueAccessor();
        $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
    },
    // tslint:disable-next-line
    update: (element: any, valueAccessor: any, allBindingsAccessor: any) => {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).lineClamp = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        // Initially set the element to be instantly visible/hidden depending on the value
        var value = ko.utils.unwrapObservable(valueAccessor());
        var maxHeight = value.maxHeight as number;
        // tslint:disable-next-line
        var valueUpdateTrigger = ko.utils.unwrapObservable(value.value);
        // tslint:disable-next-line
        var updateOn = ko.utils.unwrapObservable(value.updateOn) as any;
        $(element.parentElement).css("max-height", maxHeight);
        setTimeout(() => {
            KnockoutExtensions.applyLineClamp(element, maxHeight);
        }, 1);
    },
    // tslint:disable-next-line
    update: (element: any, valueAccessor: any, allBindingsAccessor: any) => {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = ko.utils.unwrapObservable(valueAccessor());
        var maxHeight = value.maxHeight as number;
        // tslint:disable-next-line
        var valueUpdateTrigger = ko.utils.unwrapObservable(value.value);
        // tslint:disable-next-line
        var updateOn = ko.utils.unwrapObservable(value.updateOn) as any;
        $(element.parentElement).css("max-height", maxHeight);
        setTimeout(() => {
            KnockoutExtensions.applyLineClamp(element, maxHeight);
        }, 1);
    }
};



// tslint:disable-next-line
(ko.bindingHandlers as any).copyToClipboard = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        // tslint:disable-next-line
        var value = valueAccessor() as CopyToClipboardOptions;
        //$(element).attr("data-clipboard-target", value.targetSelector);
        var clipboard = new Clipboard(element,
            {
                target: () => {
                    $("body").addClass("for-export");
                    if (value.beforeCopy) {
                        value.beforeCopy.call(data);
                    }
                    var targetElement: HTMLElement;
                    if (typeof value.targetSelector === "function") {
                        targetElement = $(value.targetSelector.call(data)).get(0);
                    } else {
                        targetElement = $(value.targetSelector).get(0);
                    }

                    var titleElement = $(".copyToClipboardReportTitle");
                    if (titleElement.length == 0) {
                        var title: string = null;
                        if (value.title != null) {
                            if (typeof value.title === "function") {
                                title = value.title.call(data);
                            } else {
                                title = value.title as string;
                            }
                        }
                    }

                    var container = $("<div id='clipboard-container'>");
                    container.html($(targetElement).html());
                    if (title != null && titleElement.length == 0) {
                        container.prepend(`<h3>${title}</h3>`);
                    }
                    container.find(".is-export-hidden").remove();

                    if (value.rightAlignTables || value.rightAlignTables == null) {
                        container.find("th.mdl-data-table__cell--non-numeric:empty").html('&nbsp;');
                        container.find("th.mdl-data-table__cell:empty").html('&nbsp;');
                        container.find("td.mdl-data-table__cell").css('text-align', 'right');
                        container.find("td.bop-value").css('text-align', 'right');
                    }
                    container.find("th.column-size-xs").css('width', '40px');
                    container.find("th.column-size-sm").css('width', '60px');
                    container.find("th.column-size-ms").css('width', '100px');
                    container.find("th.column-size-md").css('width', '150px');
                    container.find("th.column-size-lg").css('width', '250px');
                    container.find("th.column-size-xl").css('width', '350px');

                    container.find("th.column-right-align").css('text-align', 'right');
                    container.find("th.bop-column-right-align").css('text-align', 'right');
                    container.find("td.indent-level-1").css('margin-left', '12px');
                    container.find("td.indent-level-2").css('margin-left', '22px');
                    container.find("td.indent-level-3").css('margin-left', '32px');
                    container.find("td.indent-level-4").css('margin-left', '42px');
                    container.find("td.indent-level-5").css('margin-left', '52px');

                    container.find("*").removeAttr("class");
                    $("body").append(container);
                    return container.get(0);
                }
            } as Clipboard.Options);
        // ReSharper disable once Lambda
        clipboard.on("success", function (e: Clipboard.Event) {
            //$("#clipboard-container").remove();
            $("body").removeClass("for-export");
            value.success.call(data);
            e.clearSelection();
        });
        // ReSharper disable once Lambda
        clipboard.on("error", function () {
            //$("#clipboard-container").remove();
            $("body").removeClass("for-export");
            value.error.call(data);
        });
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).chart = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel: any) => {
        var allBindings = allBindingsAccessor();
        var chartBinding = allBindings.chart;
        var activeChart: Chart;
        var chartData: Chart.ChartConfiguration;

        var createChart = () => {
            var chartType = ko.unwrap(chartBinding.type);
            var data = ko.toJS(chartBinding.data);
            var options = ko.toJS(chartBinding.options);

            chartData = {
                type: chartType as Chart.ChartType,
                data: data as Chart.ChartData,
                options: options as Chart.ChartOptions
            };

            // tslint:disable-next-line
            activeChart = new Chart(($(element).get(0) as any) as HTMLCanvasElement, chartData);
        };

        var refreshChart = () => {
            chartData.data = ko.toJS(chartBinding.data);
            activeChart.update();
            activeChart.resize();
        };

        var subscribeToChanges = () => {
            ko.computed(function () {
                return ko.toJSON(chartBinding.data);
            }).subscribe(function () {
                refreshChart();
            });
        };

        createChart();
        
        if (chartBinding.options && chartBinding.options.observeChanges) {
            subscribeToChanges(); 
        }
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).stopBinding = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel: any) => {
        return { controlsDescendantBindings: true };
    }
};

/**
 * One time knockout validation initialisation for MDL.
 */
ko.validation.init({
    errorMessageClass: "mdl-textfield__error",
    messageTemplate: "validation-error-template-html",
    decorateInputElement: true,
    errorElementClass: "is-invalid"
});

// tslint:disable-next-line
ko.validation.insertValidationMessage = element => {
    var $span = $("<span/>");
    $span.insertBefore(element.nextSibling as Element);

    //if ($(element).hasClass("error-before"))
    //    element.parentNode.insertBefore(span, element);
    //else
    //    element.parentNode.insertBefore(span, element.nextSibling);
    //return null as Element;
    return $span.get(0);
};

// tslint:disable-next-line
(ko.validation as any).makeBindingHandlerValidatable("textInputWithDefault");

/**
 * Enhance the validation functionality to add the validation markup to any input wrappers (mdl uses those extensively)
 */
var init = ko.bindingHandlers["validationCore"].init;
// tslint:disable-next-line
ko.bindingHandlers["validationCore"].init = (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel?: any, bindingContext?: KnockoutBindingContext) => {
    init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    const config = ko.validation.utils.getConfigOptions(element);
    // if requested, add binding to decorate element
    if (config.decorateInputElement && ko.validation.utils.isValidatable(valueAccessor())) {
        const parent = $(element).parents(".input-wrapper");
        if (parent.length) {
            ko.applyBindingsToNode(parent[0], { validationElement: valueAccessor() });
        }
    }
};

//(ko.bindingHandlers as any).not = {
//    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel: any) => {
//        //expects a single, truthy/falsy binding,
//        //    such as checked, visible, enable, etc.
//        var binding = valueAccessor();
//        var observable = binding[Object.keys(binding)[0]];
//        var notComputed = ko.computed({
//            read: function () {
//                return !observable();
//            },
//            write: function (newValue) {
//                observable(!newValue);
//            }
//        });
//        var newBinding: any;
//        newBinding[Object.keys(binding)[0]] = notComputed;
//        ko.applyBindingsToNode(element, newBinding, viewModel);
//    }
//};

//########### LOCALIZATION HANDLING ###########
ko.bindingHandlers.localstorage = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var binding = ko.utils.unwrapObservable(valueAccessor());
        if (Object.prototype.toString.call(binding) === '[object String]') {
            binding = { key: binding };
        }
        var key = binding.key.split(':');
        var text = window.localStorage.getItem(key[0]);
        if (key.length > 0) {
            text = JSON.parse(text)[key[1]];
        }
        if (binding.prefix) {
            text = binding.prefix + text;
        }
        ko.bindingHandlers.text.update(
            element,
            function () { return text; },
            allBindingsAccessor,
            viewModel,
            context);
    }
};
ko.bindingHandlers.localstoragehref = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var binding = ko.utils.unwrapObservable(valueAccessor());
        if (Object.prototype.toString.call(binding) === '[object String]') {
            binding = { key: binding };
        }
        var key = binding.key.split(':');
        var text = window.localStorage.getItem(key[0]);
        if (key.length > 0) {
            text = JSON.parse(text)[key[1]] || "";
        }
        if (binding.prefix) {
            text = binding.prefix + text;
        }
        while (text.endsWith('/'))
            text = text.slice(0, -1);
        if (binding.relativePath && binding.relativePath.length > 0) {
            while (binding.relativePath.charAt(0) === '.' || binding.relativePath.charAt(0) === '/')
                binding.relativePath = binding.relativePath.substring(1);
            text = text + '/' + binding.relativePath;
        }
        ko.bindingHandlers.attr.update(
            element,
            function () { return { href: text }; },
            allBindingsAccessor,
            viewModel,
            context);
    }
};

//########### LOCALIZATION HANDLING ###########
ko.bindingHandlers.restext = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var text = getLocalizedText(ko.utils.unwrapObservable(valueAccessor()));
        ko.bindingHandlers.text.update(
            element,
            function () { return text; },
            allBindingsAccessor,
            viewModel,
            context);
    }
};

ko.bindingHandlers.reshtml = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var text = getLocalizedText(ko.utils.unwrapObservable(valueAccessor()));
        ko.bindingHandlers.html.update(
            element,
            function () { return text; },
            allBindingsAccessor,
            viewModel,
            context);
    }
};

ko.bindingHandlers.reshref = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var text = getLocalizedText(ko.utils.unwrapObservable(valueAccessor()));
        ko.bindingHandlers.attr.update(
            element,
            function () { return { href: text }; },
            allBindingsAccessor,
            viewModel,
            context);
    }
};

ko.bindingHandlers.ressrc = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var text = getLocalizedText(ko.utils.unwrapObservable(valueAccessor()));
        ko.bindingHandlers.attr.update(
            element,
            function () { return { src: text }; },
            allBindingsAccessor,
            viewModel,
            context);
    }
};

ko.bindingHandlers.resattr = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
        var json = ko.utils.unwrapObservable(valueAccessor());
        for (var attr in json) {
            var text = getLocalizedText(json[attr]);
            ko.bindingHandlers.attr.update(
                element,
                function () { var x = {}; x[attr] = text; return x; },
                allBindingsAccessor,
                viewModel,
                context);
        }
    }
};
function getLocalizedText(binding) {
    var resx = (window['ncResources'] as any);
    if (typeof resx === "undefined") {
        throw "ko.localationbinding.getLocalizedText: resources object is not defined";
    }

    // Accept both restext: 'mytext' and restext: { key: 'mytext' }
    if (Object.prototype.toString.call(binding) === '[object String]') {
        binding = { key: binding };
    }

    var key = binding.key;
    if (!resx.hasOwnProperty(key)) {
        throw "ko.localationbinding.getLocalizedText: Could not find key '" + key + "'.";
    }

    // Get text for locale, fallback to 'default' key or return an empty string if not text is present.
    var text = resx[key];

    // Handle placeholders, where the localized text can be 'Hello {0}!'. 
    if (binding.params) {
        for (var idx = 0; idx < binding.params.length; idx++) {
            var replacement = binding.params[idx];
            if (typeof replacement === "function") {
                replacement = ko.utils.unwrapObservable(replacement());
            }
            text = text.replace("{" + idx + "}", replacement);
        }
    }

    return text;
}
ko.bindingHandlers.restext.getText = getLocalizedText;

//########### END - LOCALIZATION HANDLING ###########


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/KnockoutExtensions/bindinghandlers.ts